import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Own scroll position ourselves: the browser default ('auto') restores
// the prior offset on reload, which would land a refreshed page mid-way
// down — and open the home intro's gate onto mid-page instead of the
// hero. Pages reset to the top on mount / route change instead.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);